<template>
  <div class="tw-flex tw-justify-end">
    <ButtonShare
      :category-event-name="categoryEventName"
      :title-name="titleName"
      :event-name="eventName"
      theme-primary-circle
      icon-size="20px"
      :class="buttonClass"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  categoryEventName?: string
  titleName?: string
  eventName?: string
  buttonClass?: string
}>()
</script>
